import React from "react";

export default function IECategorySlider({
  categories,
  selectedCategory,
  setSelectedCategory,
}) {
  return (
    <div className="ie-category-slider">

      {categories.map((cat) => (
        <div
          key={cat.name}
          className={
            selectedCategory === cat.name
              ? "ie-category active"
              : "ie-category"
          }
          onClick={() => setSelectedCategory(cat.name)}
        >
          <img
            src={cat.image}
            alt={cat.name}
          />

          <div className="ie-category-overlay" />

          <div className="ie-category-title">
            {cat.name}
          </div>

        </div>
      ))}

    </div>
  );
}